<template>
  <div class="cp-rule mobile" @click="handleClose">
    <div class="rule-wrapper">
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">活动时间：<span style="color: #990000">2023年3月10日~2022年4月30日</span></div>
      </div>
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">
          <span class="emphasis">十连抽奖：</span><br>奖励包含《原始征途》游戏道具及实物大奖，从页面公示的奖池中抽取，游戏道具品质由高到低为紫、绿、黄、蓝，抽出概率递减；幸运的用户，有机会在十连奖池之外，额外抽中实物大奖
        </div>
      </div>
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">
          <span class="emphasis">召集助力：</span><br>
          <span>
            1、默认有一次十连抽机会，还可召集兄弟助力增加机会；将页面分享给好友即可发起召集，好友助力成功后，便可增加一次10连抽的机会，最多额外增加9次。
          </span><br>
          <span>2、每位玩家仅有一次为好友助力的机会，受邀完成一次助力之后，将无法再为其他玩家进行助力。</span>
        </div>
      </div>
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">
          <span class="emphasis">绑定角色：</span><br>
          领取奖励前，玩家需要通过登录巨人通行证绑定《原始征途》公测区服中的已创建角色；本次活动仅面向公测区服，并且首次绑定后将无法换绑。
        </div>
      </div>
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">
          <span class="emphasis">游戏道具领奖：</span><br>
          <span>
            1、可以在”我的奖励“界面中查看已经抽到的奖励，并且从已经抽到的奖励任意选择10个奖励领取到游戏中。
          </span><br>
          <span>2、活动期间，玩家只能领取一次奖励，领取的奖励数量必须为10个。</span>
          <br>
          <span>3、领奖后，奖励将以自动发放至玩家绑定的《原始征途》角色账号之中，需自行前往查收。</span>
        </div>
      </div>
      <div class="rule">
        <div class="rule-content">
          <span class="emphasis">实物大奖领奖：</span><br>
          请获得实物奖励的玩家在15日内填写收件信息，逾期未填写或误填收件信息视为放弃奖励资格，将在15个工作日内为已填收件信息的玩家发放实物奖励。
        </div>
      </div>
      <div class="rule">
        <!-- <div class="rule-seq"></div> -->
        <div class="rule-content">
          <span class="emphasis">注意事项：</span><br>
          <span>
            1、如使用外挂等不正当方式参加本活动的，官方将有权取消用户参与及获奖资格。
          </span><br>
          <span>2、如有任何问题，请联系《原始征途》手游官方客服，客服电话021-61205656。</span>
        </div>
      </div>
    </div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
// 移动端头部
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import { mapState } from "vuex";
import Close from '~/components/Close/close.vue';


export default {
  name: 'share',
  components: {Close},
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  methods: {
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-rule {
    position absolute
    width 6.92rem
    height 10.67rem
    background-size: 6.92rem 9.71rem;
    background-image url('./images/rule.png')
    background-repeat: no-repeat;
    background-position top center
    .rule-wrapper {
      padding: 1.14rem 0.34rem 0;
    }
    .rule {
      font-size 0.18rem
      line-height 1.5
      width 6.12rem
      margin-bottom 0.12rem
      display flex
      color #5c3a22
      &-seq {
        width 0.25rem
        height 0.25rem
        // background-image url('./images/dot.png')
        background-size: 0.25rem 0.25rem
        background-repeat: no-repeat
        margin-top 0.07rem
        margin-right 0.17rem
      }
      &-content {
        width 6.12rem
        text-align left
      }
      .emphasis {
        color #990000
        font-weight bold
        line-height 0.38rem
      }
    }
  }
</style>
